import React from "react";
import Image from "next/image";
import { useCasinoPage } from "../CasinoPageContext";

const HeroSection = () => {
  const { website } = useCasinoPage();

  const heroBgUrl = new URL("@/app/assets/hero-bg.png", import.meta.url).href;
  const heroURl = new URL("@/app/assets/hero.png", import.meta.url).href;

  return (
    <section
      id="hero"
      className="relative bg-slate-950 text-white min-h-[80vh] py-16 md:py-20 flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${heroBgUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute bg-black inset-0 opacity-30"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-12 items-center">
          {/* Text Section */}
          <div className="order-2 lg:order-1 py-6 lg:py-0 text-center lg:text-left max-w-xl mx-auto lg:mx-0">
            <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold leading-snug md:leading-tight mb-2 md:mb-3 text-white">
              {website?.homepageContent?.welcomeSection.title}
            </h1>
            {/* Helper line to ensure H1 words are clearly present in body text for SEO crawlers */}
            <p className="text-xs sm:text-sm text-cyan-300/90 mb-2 max-w-xl mx-auto lg:mx-0">
              Discover a world of global casino games, exclusive bonuses, and
              winning strategies—powered by Casino24.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-4 md:mb-6 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {website?.homepageContent?.welcomeSection.description}
            </p>
            <div className="mt-2 md:mt-4">
              <a
                href="https://www.casino24.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-600 text-black text-sm md:text-base font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-transform transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-slate-950"
              >
                Ready to Play?
              </a>
            </div>
          </div>

          {/* Image Section */}
          <div className="flex justify-center items-center p-4 lg:p-0 order-1 lg:order-2">
            <Image
              src={heroURl}
              alt={
                website?.homepageContent?.businessName ||
                website?.parentKeyword ||
                "Online casino hero image"
              }
              width={640}
              height={480}
              priority
              className="h-full w-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
